// extracted by mini-css-extract-plugin
export default {"paper":"SeatReservationCheckoutUi_paper__R4L9A"};